import { define } from '../redux-request';
import api from '../../api/api';

export const GET_DASHBOARD_STATS = define('GET_DASHBOARD_STATS');

export function getDashboardStatsRequest(data) {
  return GET_DASHBOARD_STATS.request(() => api.getDashboardStats(data));
}

export const GET_DASHBOARD_CHART = define('GET_DASHBOARD_CHART');

export function getDashboardChartRequest(data) {
  return GET_DASHBOARD_CHART.request(() => api.getDashboardChart(data));
}

export const GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS = define('GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS');

export function getDashboardGrowthBySpecializationsRequest(data) {
  return GET_DASHBOARD_GROWTH_BY_SPECIALIZATIONS.request(() => api.getDashboardGrowthBySpecializations(data));
}

export const GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK = define('GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK');

export function getDashboardSyncPakVsSortPakRequest(data) {
  return GET_DASHBOARD_SYNC_PAK_VS_SORT_PAK.request(() => api.getDashboardSyncPakVsSortPak(data));
}

export const GET_DASHBOARD_REP_SCORECARD = define('GET_DASHBOARD_REP_SCORECARD');

export function getDashboardRepScorecard(data) {
  return GET_DASHBOARD_REP_SCORECARD.request(() => api.getDashboardRepScorecard(data));
}

export const GET_DASHBOARD_USER_WORKFLOW = define('GET_DASHBOARD_USER_WORKFLOW');

export function getDashboardUserWorkflowRequest(data) {
  return GET_DASHBOARD_USER_WORKFLOW.request(() => api.getDashboardUserWorkflow(data));
}

export const GET_DASHBOARD_SCRIPT_WORKFLOW = define('GET_DASHBOARD_SCRIPT_WORKFLOW');

export function getDashboardScriptWorkflowRequest(data) {
  return GET_DASHBOARD_SCRIPT_WORKFLOW.request(() => api.getDashboardScriptWorkflow(data));
}

export const GET_DASHBOARD_NEW_PHYSICIAN = define('GET_DASHBOARD_NEW_PHYSICIAN');

export function getDashboardNewPhysician(data) {
  return GET_DASHBOARD_NEW_PHYSICIAN.request(() => api.getDashboardNewPhysician(data));
}

export const SEARCH_PRODUCT = define('SEARCH_PRODUCT');

export function searchProduct(search) {
  return SEARCH_PRODUCT.request(() => api.searchProduct(search));
}

export const CLEAR_PRODUCT = 'CLEAR_PRODUCT';

export function clearProduct() {
  return {
    type: CLEAR_PRODUCT,
  };
}

export const GET_TOP_MEDICATION = define('GET_TOP_MEDICATION');

export function getTopMedications(data) {
  return GET_TOP_MEDICATION.request(() => api.getTopMedications(data));
}

export const GET_TOP_CITIES = define('GET_TOP_CITIES');

export function getTopCities(data) {
  return GET_TOP_CITIES.request(() => api.getTopCities(data));
}

export const GET_TOP_STATE = define('GET_TOP_STATE');

export function getTopState(data) {
  return GET_TOP_STATE.request(() => api.getTopState(data));
}

export const GET_TOP_SPECIALIZATIONS = define('GET_TOP_SPECIALIZATIONS');

export function getTopSpecializations(data) {
  return GET_TOP_SPECIALIZATIONS.request(() => api.getTopSpecializations(data));
}

export const GET_TOP_COPAY_NETWORKS = define('GET_TOP_COPAY_NETWORKS');

export function getTopTopCopayNetworks(data) {
  return GET_TOP_COPAY_NETWORKS.request(() => api.getTopTopCopayNetworks(data));
}

export const GET_TOP_PAYORS = define('GET_TOP_PAYORS');

export function getTopPayors(data) {
  return GET_TOP_PAYORS.request(() => api.getTopPayors(data));
}

export const GET_UNASSIGNED_PHYSICIANS = define('GET_UNASSIGNED_PHYSICIANS');

export function getUnassignedPhysicians(data) {
  return GET_UNASSIGNED_PHYSICIANS.request(() => api.getUnassignedPhysicians(data));
}

export const GET_TOP_PHYSICIANS = define('GET_TOP_PHYSICIANS');

export function getTopPhysicians(data) {
  return GET_TOP_PHYSICIANS.request(() => api.getTopPhysicians(data));
}

export const GET_TOP_GROUPS = define('GET_TOP_GROUPS');

export function getTopGroups(data) {
  return GET_TOP_GROUPS.request(() => api.getTopGroups(data));
}

export const GET_TOP_HUBS = define('GET_TOP_HUBS');

export function getTopHubsRequest(data) {
  return GET_TOP_HUBS.request(() => api.getTopHubs(data));
}

export const GET_SINGLE_REPORT = define('GET_SINGLE_REPORT');

export function getSingleReportRequest(data, pageLimit) {
  return GET_SINGLE_REPORT.request(() => api.getSingleReport(data, pageLimit));
}

export const GET_DASHBOARD_NOTE_COUNT = define('GET_DASHBOARD_NOTE_COUNT');

export function getDashboardNoteCountRequest(data) {
  return GET_DASHBOARD_NOTE_COUNT.request(() => api.getDashboardNoteCount(data));
}
